const CLOUDFLARE_STICKER_FUNCTION_BASE_URL =
  "https://mousewait-sticker-fairy-dev.timejarmail.workers.dev";

export const STICKER_FAIRY_TEXT_FUNCTION = "gemini-text-to-sticker";
export const STICKER_FAIRY_IMAGE_FUNCTION = "gemini-image-to-sticker";

const normalizeBaseUrl = (value?: string) => {
  const trimmed = String(value || "").trim();
  return trimmed.replace(/\/+$/, "");
};

export const getStickerFairyFunctionBaseUrl = () =>
  normalizeBaseUrl(process.env.REACT_APP_STICKER_FAIRY_FUNCTION_BASE_URL) ||
  CLOUDFLARE_STICKER_FUNCTION_BASE_URL;

export const buildStickerFairyFunctionUrl = (
  functionName: string,
  baseUrl = getStickerFairyFunctionBaseUrl()
) => `${normalizeBaseUrl(baseUrl)}/${functionName.replace(/^\/+/, "")}`;

export const buildStickerFairyRequestHeaders = ({
  contentType,
}: {
  baseUrl?: string;
  contentType?: string;
} = {}) => {
  const headers: Record<string, string> = {};
  if (contentType) {
    headers["Content-Type"] = contentType;
  }
  return headers;
};
